const styles = {
  tabIndicator: {
    display: 'none',
  },
  tab: {
    fontWeight: 600,
    textTransform: 'none',
    backgroundColor: '#D9E9E9',
    borderRadius: 50,
    height: '25px',
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: 'black',
    },
  },
  tabWrapper: {
    backgroundColor: '#D9E9E9',
    padding: '6px 10px 6px 10px',
    borderRadius: 50,
  },
  tabContainer: {
    margin: '0 40px 10px 40px',
  },
};

export default styles;
